/**
 * @fileoverview stamp entity object is class for entry stamp entity canvas view.
 */

'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _GEHelper = require("../graphicEngine/GEHelper");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Construct stamp entity class
 * @param {!Entry.EntryObject} object
 * @param {!Entry.EntityObject} entity
 * @constructor
 */
Entry.StampEntity = /*#__PURE__*/function (_Entry$EntityObject) {
  function StampEntity(object, entity) {
    var _this;
    (0, _classCallCheck2["default"])(this, StampEntity);
    /** @type {!string} */
    _this = _callSuper(this, StampEntity, [object]);
    _this.parent = object;
    _this.type = object.objectType;
    _this.isClone = true;
    _this.isStamp = true;
    _this.width = entity.getWidth();
    _this.height = entity.getHeight();
    if (_this.type == 'sprite') {
      _this.object = _GEHelper.GEHelper.cloneStamp(entity);
      if (entity.effect) {
        _this.effect = _.clone(entity.effect);
        _this.applyFilter();
      }
    } else if (_this.type == 'textBox') {}
    _this.object.entity = entity;
    return _this;
  }
  (0, _inherits2["default"])(StampEntity, _Entry$EntityObject);
  return (0, _createClass2["default"])(StampEntity);
}(Entry.EntityObject);